import React from "react";
import "./AboutSection.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function AboutSection() {
  const reasons = [
    {
      num: "01",
      title: "Proven Expertise",
      desc: "With years of experience in Sportsbook, Exchange, and Casino. We deliver platforms built for performance and stability. Our engineering excellence ensures smooth, scalable, and high-traffic operations."
    },
    {
      num: "02",
      title: "End-to-End Ecosystem",
      desc: "We provide everything from development to deployment, integrations, and maintenance. This unified ecosystem helps you launch faster and run your iGaming business effortlessly."
    },
    {
      num: "03",
      title: "Advanced Security",
      desc: "Our multi-layer security framework protects your platform from fraud, breaches, bots, and cyber threats. We ensure complete compliance, secure transactions, and uninterrupted gameplay."
    },
    {
      num: "04",
      title: "Powerful Back office",
      desc: "Our Powerful and Smart back-office system gives you complete control over users, risk, markets, payments, and operations from a single dashboard. Designed for speed and accuracy."
    },
    {
      num: "05",
      title: "Full Ownership",
      desc: "You receive full control and complete ownership of your platform and source code. This eliminates vendor lock-ins and ensures long-term business independence."
    },
    {
      num: "06",
      title: "24/7 Support",
      desc: "Our dedicated support team monitors and assists your platform around the clock. From technical issues to performance optimization, we ensure seamless operations every day."
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Why Choose Us</div>
          <h2 className="section-title">
            Why <span className="gradient-text">360 Gaming Labs</span> is trusted Partner<br />
            for Next-Gen iGaming Solutions
          </h2>
        </div>

        <div className="about-grid">
          {reasons.map((item, index) => (
            <div key={index} className="about-card" data-index={index}>
              <div className="card-number-large">{item.num}</div>
              
              <div className="card-content">
                <h3 className="about-card-title">{item.title}</h3>
                <p className="about-card-desc">{item.desc}</p>
              </div>

              <div className="card-gradient-line"></div>
              <div className="card-hover-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
